import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";

import { GET_USER_REJECTED_CI } from "../../AppConstant";
import SeePage from "./See";

function UserRejected({ setParentLoading }) {
    const [accepted, setAccepted] = useState([]);

    const getAccepted = async () => {

        try {
            setParentLoading(true);
            const empid = localStorage.getItem("empid");

            const res = await axios.get(GET_USER_REJECTED_CI, {
                params: { empid }
            });
            setAccepted(res.data);
            console.log("API response:", res.data);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        } catch (err) {
            console.error(err);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        }
    };

    useEffect(() => {
        getAccepted();
    }, []);

    const generateStage = (item) => {

        const normalize = (val) =>
            val === null || val === undefined || val === ""
                ? null
                : val.toString().trim().toLowerCase();

        const VA = normalize(item.isvalidatorapproved);
        const AA = normalize(item.isapproverapproved);
        const status = item.status;


        if (status === "U") {
            // return "Update request have been given, please update it, check comments for more details"
            return "";
        }

        if (!VA) {
            // return "Pending with Reporting Manager";
            return "Validator";
        }

        if (VA === "rejected") {
            // return "Rejected (Reporting Manager)";
            return "Validator";
        }

        if (VA === "approved" && !AA) {
            // return "Pending with Approver";
            return "Approver";
        }

        if (AA === "rejected") {
            // return "Rejected (Approver)";
            return "Approver";
        }

        if (status === "A") {
            // return "ACCEPTED";
            return "";
        }

        return "Unknown";
    };
    const [showSeeModal, setShowSeeModal] = useState(false);

    const handleOpenSeeModal = async (item) => {
        localStorage.setItem('swipexid', item.id)
        localStorage.setItem('swipexempid', item.empid)
        setParentLoading(true);
        setShowSeeModal(true);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const handleCloseSeeModal = () => {
        setParentLoading(true);
        setShowSeeModal(false);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

      const [searchTerm, setSearchTerm] = useState("");
        
            const filteredRecords = accepted.filter((item) => {
            const searchableText = [
                ...Object.values(item),
                generateStage(item)
            ]
                .join(" ")
                .toLowerCase();
        
            return searchableText.includes(searchTerm.toLowerCase());
        });

         const [expandedComment, setExpandedComment] = useState(null);
        
        const handleSeeMore = (index) => {
          setExpandedComment(expandedComment === index ? null : index);
        };

    return (
        <div>

            <div className="input-group mb-3" style={{ width: "500px" }}>
    <span className="input-group-text">
        <i className="bi bi-search"></i>
    </span>

    <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
    />
</div>

            <table className="mt-1 fw-bold" style={{fontSize:"small"}}>
                <thead className="bg-success-subtle" style={{ width:"100%", color:"green" }} >
                    <tr style={{width:"100%"}}>
                        <th style={{width:"5%"}}>S.No</th>
                        <th style={{width:"10%"}}>SWIPEX ID</th>
                        <th style={{width:"15%"}}>TITLE</th>
                        <th style={{width:"15%"}}>REPORTING MANAGER</th>
                        <th style={{width:"17%"}}>COMMENTS</th>
                        <th style={{width:"10%"}}>REJECTED BY </th>
                        <th style={{width:"10%"}}>ACTION</th>
                        <th style={{width:"9%"}}>CREATED AT</th>
                        <th style={{width:"9%"}}>REJECTED AT</th>
                    </tr>
                </thead>

                <tbody className="text-white" style={{ fontSize: "small" }}>
                    {filteredRecords.length > 0 ? (
                        filteredRecords.map((sub, index) => (
                            <tr key={sub.id}>

                                <td>{index + 1}</td>
                                <td>{sub.id}</td>
                                <td>{sub.title}</td>
                                <td>{sub.validatorname}</td>
                                <td title={sub.comments}>
  {expandedComment === index || sub.comments?.length <= 40 ? (
    sub.comments
  ) : (
    <>
      {sub.comments.substring(0, 40)}...
      <i
        onClick={() => handleSeeMore(index)}
        style={{
          color: "black",
          cursor: "pointer",
          marginLeft: "5px",
        }}
      >
        See more
      </i>
    </>
  )}
</td>

  <td style={{color:"orangered"}}>
                                   
                                        {sub.isvalidatorapproved == "rejected"
                                            ? "Validator"
                                            : sub.isapproverapproved == "rejected"
                                                ? "Approver"
                                                    : "Unknown"}
                                </td>
                                <td>
                                    <div className="d-flex justify-content-center fw-bold" style={{ fontSize: "18px" }}>
                                        <i class="bi bi-eye-fill" style={{ color: "blue", cursor: "pointer" }} title="See" onClick={() => handleOpenSeeModal(sub)}></i>
                                    </div>
                                </td>

                                 <td>
                                    {new Date(sub.createdat.replace(" ", "T"))
                                        .toLocaleString("en-GB", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(",", "")}
                                </td> 

                                <td>
                                    {new Date(sub.lastupdatedat.replace(" ", "T"))
                                        .toLocaleString("en-GB", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(",", "")}
                                </td>      
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="9" style={{ textAlign: "center", color:"white" }}>
                                 No records available...!
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>


            <Modal
                show={showSeeModal}
                onHide={handleCloseSeeModal}
                backdrop="static"
                keyboard={false}
                fullscreen
            >
                <SeePage handleCloseSeeModal={handleCloseSeeModal} setParentLoading={setParentLoading} />
            </Modal>

        </div>
    );
}

export default UserRejected;